import mongoose from 'mongoose';
import originalServicePayload, {
  IOriginalServicePayloadDocument,
} from '../schemas/original-service-payload';

export default (mongoose.models.OriginalServicePayload ||
  mongoose.model<IOriginalServicePayloadDocument>(
    'OriginalServicePayload',
    originalServicePayload,
  )) as mongoose.Model<IOriginalServicePayloadDocument>;
